import { useContext } from "react";

import OrganizationAPI from "@services/api/old/organization/OrganizationAPI";

import { ApplicationContext } from "./ApplicationContext";

export default function useApplicationContext() {
  const context = useContext(ApplicationContext);
  if (context === undefined) {
    throw new Error(
      "useApplicationContext must be used within a ApplicationContextProvider",
    );
  }
  return context;
}

export function useOrganizationAppContext() {
  const { organization, setOrganization } = useApplicationContext();
  if (!organization) {
    throw new Error(
      "You are not associated with a organization. Please contact support.",
    );
  }
  return { organization, setOrganization };
}

export function useOrganizationContextRefresh() {
  const { setOrganization, organization } = useApplicationContext();
  return () => {
    if (organization) {
      OrganizationAPI.getOrganization(organization.id).then((org) => {
        setOrganization(org);
      });
    }
  };
}
